import {createSvgIcon} from '../create-svg-icon';

export const CasinoIcon = createSvgIcon(
  [<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z" key="0" />,<circle cx="7.5" cy="16.5" r="1.5" key="1" />,<circle cx="7.5" cy="7.5" r="1.5" key="2" />,<circle cx="12" cy="12" r="1.5" key="3" />,<circle cx="16.5" cy="16.5" r="1.5" key="4" />,<circle cx="16.5" cy="7.5" r="1.5" key="5" />,]
, 'CasinoOutlined');
